import React from 'react';
import { bunnyProducts } from '../../bunnyMock';
import { Check, ShoppingCart } from 'lucide-react';

const BunnyProductSection = () => {
  return (
    <section id="products" className="section-spacing bunny-section-dark">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl sm:text-6xl font-serif bunny-headline text-white mb-4">
            Featured Collection
          </h2>
          <p className="text-xl text-gray-300 font-sans max-w-2xl mx-auto">
            Trend-driven pieces that make you look & feel incredible
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {bunnyProducts.map((product, index) => (
            <div 
              key={product.id} 
              className="bg-white bunny-card p-0 overflow-hidden"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Product Image Placeholder with Tag */}
              <div className="h-80 bg-gradient-to-br from-pink-200 via-gray-100 to-yellow-100 flex items-center justify-center relative">
                <span className="text-7xl font-serif text-gray-300">WB</span>
                <div className="absolute top-4 left-4">
                  <span className="bunny-tag">{product.tag}</span>
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-2xl font-serif bunny-headline text-gray-900 mb-3">
                  {product.name}
                </h3>
                <p className="text-base text-gray-600 font-sans mb-6">
                  {product.description}
                </p>

                <ul className="space-y-3 mb-6">
                  {product.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <Check className="w-5 h-5 bunny-accent-pink flex-shrink-0 mt-0.5" />
                      <span className="text-sm font-sans text-gray-700 font-medium">{benefit}</span>
                    </li>
                  ))}
                </ul>

                <div className="flex items-center justify-between">
                  <span className="text-3xl font-serif bunny-headline text-gray-900">
                    ${product.price}
                  </span>
                  <button className="bunny-btn-primary px-6 py-3 text-sm flex items-center gap-2">
                    <ShoppingCart className="w-4 h-4" />
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BunnyProductSection;
